import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";

import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AuthenticationStateManager from "components/navigation/AuthenticationStateManager";
import ProtectedRoute from "components/navigation/ProtectedRoute";
// Pages
import NotFound from "pages/NotFound";
import Register from "pages/Register";
import HomeLanding from "./pages/home-landing/homeLandingMain";
import PricingPlans from "./pages/pricing-plans/pricingPlansMain";
import BlogContentHub from "./pages/blog-content-hub/blogContentHubMain";
import BlogDetail from "./pages/blog-content-hub/BlogDetail.jsx";
import AuthenticationPortal from "./pages/authentication-portal/authenticationPortalMain";
import AboutPlatform from "./pages/about-platform/aboutMain";
import JobHunter from "./pages/job-hunter/JobHunter";
import CompanyQuestions from "./pages/CompanyQuestions";
import AdminRoutes from "pages/admin/routes/AdminRoutes";
import CandidateRoutes from "pages/candidate/routes/CandidateRoutes";
import ResumeBuilder from "./pages/resume-builder/ResumeBuilder";
import ResumeResults from "./pages/resume-builder/ResumeResults";
import ResumeEditor from "./pages/candidate/resume/analysis/components/ResumeEditor";

import Instructions from "./pages/intern-test/Instructions";
import TestLanding from "./pages/intern-test/TestLanding";
import TestPage from "./pages/intern-test/TestPage";
import ThankYou from "./pages/intern-test/ThankYou";
import AIMockInterviewIndia from "./pages/AIMockInterviewIndia";




import BootcampLanding from "./pages/bootcamp/BootcampLanding";
import BootcampRegister from "./pages/bootcamp/BootcampRegister";
import BootcampHub from "./pages/bootcamp/BootcampHub";
import FeedbackForm from "./pages/bootcamp/feedback/FeedbackForm";
import FeedbackSuccess from "./pages/bootcamp/feedback/FeedbackSuccess";
const Routes = () => {
  return (

      <ErrorBoundary>
        <AuthenticationStateManager>
          <ScrollToTop />

          <RouterRoutes>
            {/* PUBLIC ROUTES */}
            <Route path="/" element={<HomeLanding />} />
            <Route path="/home-landing" element={<HomeLanding />} />
            <Route path="/pricing-plans" element={<PricingPlans />} />
            <Route path="/blog-content-hub" element={<BlogContentHub />} />
             <Route path="/blog/:slug" element={<BlogDetail />} />

            <Route path="/authentication-portal" element={<AuthenticationPortal />} />
            <Route path="/about-platform" element={<AboutPlatform />} />
            <Route path="/company-questions" element={<CompanyQuestions />} />


            {/* PROTECTED ROUTES */}
          
            <Route path="/job-hunter" element={<JobHunter />} />
            <Route path="/resume/editor" element={<ResumeEditor />} />
           
 {/* ✅ ADMIN ROOT */}
<Route
  path="/admin/*"
  element={
    <ProtectedRoute allowedRoles={["ADMIN"]}>
      <AdminRoutes />
    </ProtectedRoute>
  }
/>
<Route
  path="/candidate/*"
  element={
    <ProtectedRoute allowedRoles={["STUDENT", "USER","Student"]}>
      <CandidateRoutes />
    </ProtectedRoute>
  }
/>
      <Route path="/resume-builder" element={<ResumeBuilder />} />
      <Route path="/resume-results" element={<ResumeResults />} />

      <Route path="/intern-test/:testId" element={<Instructions />} />
<Route path="/intern-test/:testId/start" element={<TestLanding />} />
<Route path="/intern-test/:testId/exam" element={<TestPage />} />
<Route path="/intern-test/:testId/thank-you" element={<ThankYou />} />

<Route
  path="/bootcamp/register/:bootcampId"
  element={<BootcampRegister />}
/>
<Route path="/bootcamp" element={<BootcampHub/>}/>
<Route path="/ai-mock-interview-india" element={<AIMockInterviewIndia />} />



            {/* HIDDEN ROUTE - Not accessible via UI */}
            <Route path="/register" element={<Register />} />
            <Route path="/feedback/:bootcampId" element={<FeedbackForm />} />
            <Route path="/feedback-success" element={<FeedbackSuccess />} />
            {/* 404 */}
            
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AuthenticationStateManager>
      </ErrorBoundary>

  );
};

export default Routes;
